module.exports = __webpack_public_path__ + "static/media/subway.505dcc9b.svg";